import { useEffect, useRef, useState } from "react";
import { UploadSimple, Trash, SpinnerGap } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, errMsg, img } from "@/lib/api";

export default function SiteContent() {
  const [site, setSite] = useState(null);
  const [busy, setBusy] = useState(false);
  const ref = useRef();
  useEffect(() => { api.get("/site").then((r) => setSite(r.data)); }, []);

  const save = async (founder_photo) => {
    const r = await api.put("/admin/site", { founder_photo });
    setSite(r.data);
  };
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const up = await api.post("/uploads", fd);
      await save(up.data.url);
      toast.success("Founder photo updated on the landing page");
    } catch (err) { toast.error(errMsg(err, "Upload failed")); }
    finally { setBusy(false); e.target.value = ""; }
  };
  const remove = async () => {
    try { await save(""); toast.success("Photo removed, initials will show instead"); } catch (err) { toast.error(errMsg(err)); }
  };

  if (!site) return null;
  return (
    <div data-testid="admin-site-content">
      <h1 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">Landing page</h1>
      <p className="mt-2 text-[#A39E9A]">Content shown in the About section of hostkey.online.</p>
      <section className="mt-8 flex flex-wrap items-center gap-6 rounded-2xl border border-[#302B28] bg-[#1E1A18] p-6">
        <div className="h-28 w-28 overflow-hidden rounded-2xl bg-[#D96C4A]" data-testid="site-founder-preview">
          <img src={site.founder_photo ? img(site.founder_photo) : "/founder.jpg"} alt="Ibrahim Mugawe" className="h-full w-full object-cover" />
        </div>
        <div>
          <p className="font-display text-xl">Founder photo</p>
          <p className="text-sm text-[#A39E9A]">Ibrahim Mugawe, Founder & CEO. A square photo works best (JPG, PNG or WEBP, under 8 MB).</p>
          <div className="mt-4 flex gap-2">
            <button onClick={() => ref.current.click()} disabled={busy} data-testid="site-founder-upload-button" className="inline-flex h-10 items-center gap-2 rounded-lg bg-[#D96C4A] px-4 text-sm font-semibold text-white hover:bg-[#C25D3E] disabled:opacity-60">
              {busy ? <SpinnerGap className="animate-spin" /> : <UploadSimple />} {site.founder_photo ? "Replace photo" : "Upload photo"}
            </button>
            {site.founder_photo && <button onClick={remove} data-testid="site-founder-remove-button" className="inline-flex h-10 items-center gap-2 rounded-lg border border-[#302B28] px-4 text-sm font-semibold hover:bg-[#302B28]"><Trash /> Remove</button>}
          </div>
          <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} data-testid="site-founder-input" />
        </div>
      </section>
    </div>
  );
}
